<template>
    <div class="order_detail my_order">
        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Order Details
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="order_detail_section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="dashboard_design d-md-flex mb_82">
                            <div class="side_bar px-0 sidebar_desk">
                                <ul class="side_bar_links mt_2 p-0">
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/myorder.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Orders</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/saved_design.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Saved Designs</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/upload_img.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Uploaded Images</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/payement.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Payment Options</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/fav.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Favorite</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/edit_profile.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Edit Profile</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class="active"
                                            ><img
                                                src="/maincss/images/mystore.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Store</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_payment.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Player</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_team.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Team</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/logout.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Logout</a
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div class="sidebar_mobile">
                                <a class="dropdown-toggle" id="item2" href="#"
                                    >My Account</a
                                >
                                <div class="side_bar px-0">
                                    <ul
                                        id="submenu2"
                                        class="side_bar_links mt_2 p-0 dropdown"
                                    >
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/myorder.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Orders</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/saved_design.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Saved Designs</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/upload_img.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Uploaded Images</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/payement.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Payment Options</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/fav.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Favorite</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/edit_profile.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Edit Profile</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class="active"
                                                ><img
                                                    src="/maincss/images/mystore.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Store</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_payment.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Player</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_team.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Team</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/logout.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Logout</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="left_panel">
                                <h2 class="font_size_20">Order Details</h2>
                                <div
                                    class="contact_detail_wrap top_wrap position-relative"
                                >
                                    <div class="row">
                                        <div class="col-lg-4 col-md-12">
                                            <div class="order_num">
                                                <h3>#110051025</h3>
                                                <p class="font_size_14">
                                                    Ordered On: Nov 19, 2020
                                                </p>
                                                <div class="back_order_btn">
                                                    <a
                                                        class="btn red_color font_size_14"
                                                        href=""
                                                        >Back Order</a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6">
                                            <div class="order_num">
                                                <h3>Adam Williams</h3>
                                                <div
                                                    class="bill_details font_size_14"
                                                >
                                                    <p>BILL TO</p>
                                                    <div class="bill-details">
                                                        Adam Williams <br />
                                                        45655 Harcourt Dr Boise
                                                    </div>
                                                    <div class="contact-info">
                                                        <span
                                                            ><img
                                                                alt=""
                                                                src="/maincss/images/icons/call.svg"
                                                        /></span>
                                                        <span
                                                            >(555)
                                                            555-1234</span
                                                        >
                                                    </div>
                                                    <div class="contact-info">
                                                        <span
                                                            ><img
                                                                alt=""
                                                                src="/maincss/images/icons/envelope.svg"
                                                        /></span>
                                                        <span
                                                            >adam.williams@gmail.com</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6">
                                            <div class="order_num mt_40">
                                                <div
                                                    class="bill_details font_size_14"
                                                >
                                                    <p>
                                                        SHIP TO
                                                        <span
                                                            >(GROUP
                                                            SHIPMENT)</span
                                                        >
                                                    </p>
                                                    <div class="bill-details">
                                                        James Williams <br />
                                                        58655 New Davea Butler
                                                        Road
                                                    </div>
                                                    <div class="contact-info">
                                                        <span
                                                            ><img
                                                                alt=""
                                                                src="/maincss/images/icons/call.svg"
                                                        /></span>
                                                        <span
                                                            >(555)
                                                            555-1234</span
                                                        >
                                                    </div>
                                                    <div class="contact-info">
                                                        <span
                                                            ><img
                                                                alt=""
                                                                src="/maincss/images/icons/envelope.svg"
                                                        /></span>
                                                        <span
                                                            >adam.williams@gmail.com</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="threedots_img">
                                        <a href="#"
                                            ><img
                                                alt=""
                                                src="/maincss/images/threedots.svg"
                                        /></a>
                                    </div>
                                </div>
                                <div
                                    class="accordian_detals contact_detail_wrap"
                                >
                                    <div class="acc">
                                        <div class="acc__card">
                                            <div class="acc__title acc_head">
                                                Base Product
                                            </div>
                                            <div class="acc__panel">
                                                <div class="row border_row">
                                                    <div
                                                        class="col-lg-4 col-md-12"
                                                    >
                                                        <div class="acc_wrap">
                                                            <h4>
                                                                Base Product
                                                            </h4>
                                                            <div
                                                                class="acc_content d-flex"
                                                            >
                                                                <div
                                                                    class="acc_img"
                                                                >
                                                                    <img
                                                                        alt=""
                                                                        src="/maincss/images/mug_img.png"
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="acc_right"
                                                                >
                                                                    <h5
                                                                        class="font_size_16"
                                                                    >
                                                                        Classic
                                                                        c-handle
                                                                        11oz Mug
                                                                    </h5>
                                                                    <div
                                                                        class="color_cat d-flex"
                                                                    >
                                                                        <div
                                                                            class="pro_color"
                                                                        >
                                                                            <span
                                                                                class="font_size_14"
                                                                                >color:</span
                                                                            ><span
                                                                                class="color-sample"
                                                                            ></span>
                                                                        </div>
                                                                        <div
                                                                            class="pro_cat font_size_14"
                                                                        >
                                                                            Category
                                                                            :
                                                                            Special
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="pro_size font_size_14"
                                                                    >
                                                                        <span
                                                                            >S
                                                                            :</span
                                                                        ><span
                                                                            class="size"
                                                                            >10
                                                                            @
                                                                            $10
                                                                            =
                                                                            $100</span
                                                                        >
                                                                    </div>
                                                                    <div
                                                                        class="pro_size font_size_14"
                                                                    >
                                                                        <span
                                                                            >L
                                                                            :</span
                                                                        ><span
                                                                            class="size"
                                                                        >
                                                                            4 @
                                                                            $15
                                                                            =
                                                                            $60</span
                                                                        >
                                                                    </div>
                                                                    <div
                                                                        class="pro_qnt font_size_14"
                                                                    >
                                                                        Total
                                                                        Quantity
                                                                        : 14
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-lg-4 col-md-12 borde_left_right"
                                                    >
                                                        <div class="acc_wrap">
                                                            <h4>
                                                                Artwork - Vinyl
                                                            </h4>
                                                            <div
                                                                class="acc_content d-flex"
                                                            >
                                                                <div
                                                                    class="acc_img"
                                                                >
                                                                    <img
                                                                        alt=""
                                                                        src="/maincss/images/mug_2.png"
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="acc_right"
                                                                >
                                                                    <div
                                                                        class="color_cat d-flex"
                                                                    >
                                                                        <div
                                                                            class="pro_color font_size_14"
                                                                        >
                                                                            <span
                                                                                >Design
                                                                                Per
                                                                                Unit:
                                                                                $2.50</span
                                                                            >
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="pro_size font_size_14"
                                                                    >
                                                                        14 @
                                                                        $2.50 =
                                                                        $35
                                                                    </div>
                                                                    <div
                                                                        class="pro_qnt font_size_14"
                                                                    >
                                                                        Design
                                                                        Price:
                                                                        $35
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-lg-4 col-md-12"
                                                    >
                                                        <div class="acc_wrap">
                                                            <h4>Cost</h4>
                                                            <div
                                                                class="cost_col"
                                                            >
                                                                <div
                                                                    class="cost_v d-flex font_size_14"
                                                                >
                                                                    <span
                                                                        >Base</span
                                                                    >
                                                                    <span
                                                                        >$160</span
                                                                    >
                                                                </div>
                                                                <div
                                                                    class="cost_v d-flex font_size_14"
                                                                >
                                                                    <span
                                                                        >Design</span
                                                                    >
                                                                    <span
                                                                        >$160</span
                                                                    >
                                                                </div>
                                                                <div
                                                                    class="cost_v d-flex font_size_14"
                                                                >
                                                                    <span
                                                                        >Setup</span
                                                                    >
                                                                    <span
                                                                        >$160</span
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-8"></div>
                                                    <div
                                                        class="col-lg-4 col-md-12"
                                                    >
                                                        <div
                                                            class="cost_col margin_mobile_30"
                                                        >
                                                            <div
                                                                class="tp_in cost_v d-flex"
                                                            >
                                                                <span
                                                                    class="tp_1 font_size_15 pb_0 pl_22"
                                                                    >Total
                                                                    Price</span
                                                                ><span
                                                                    class="tp_2 pb_0 font_size_24"
                                                                    >$210</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="contact_detail_wrap px_30 pt_40 pb_36"
                                >
                                    <div class="text_box_area">
                                        <div class="textbox_heading d-flex">
                                            <h4>Note</h4>
                                            <div class="select_option sec_opt">
                                                <label>To</label
                                                ><select>
                                                    <option
                                                        value=""
                                                        disabled="disabled"
                                                        selected="selected"
                                                    >
                                                        User
                                                    </option>
                                                    <option value="User">
                                                        User
                                                    </option>
                                                    <option value="User">
                                                        User
                                                    </option>
                                                    <option value="User">
                                                        User
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="text_editor">
                                            <img
                                                alt=""
                                                src="/maincss/images/text_box.png"
                                            />
                                        </div>
                                        <div class="comment_wrap">
                                            <div class="comment_section">
                                                <h4>Recent Comments (2)</h4>
                                                <div
                                                    class="comment_box_wrap team_img_name d-flex order_comments"
                                                >
                                                    <div
                                                        class="comm_img team_img"
                                                    >
                                                        <span
                                                            class="font_size_14 font-weight-bold"
                                                            >GP</span
                                                        >
                                                    </div>
                                                    <div
                                                        class="comment_area font_14"
                                                    >
                                                        <div class="name_time">
                                                            <span class="name"
                                                                >Adam
                                                                Williams</span
                                                            ><span
                                                                class="time grey_color font_size_14"
                                                                >9hrs ago</span
                                                            >
                                                        </div>
                                                        <div
                                                            class="comments font_size_14"
                                                        >
                                                            Lorem Ipsum is
                                                            simply dummy text of
                                                            the printing and
                                                            typesetting
                                                            industry.
                                                        </div>
                                                        <div
                                                            class="reply grey_color font_size_14"
                                                        >
                                                            Reply
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="comment_section msg_reply"
                                            >
                                                <div
                                                    class="comment_box_wrap team_img_name d-flex order_comments"
                                                >
                                                    <div
                                                        class="comm_img team_img"
                                                    >
                                                        <span
                                                            class="font_size_14 font-weight-bold"
                                                            >GP</span
                                                        >
                                                    </div>
                                                    <div
                                                        class="comment_area font_14"
                                                    >
                                                        <div class="name_time">
                                                            <span class="name"
                                                                >Adam
                                                                Williams</span
                                                            ><span
                                                                class="time grey_color font_size_14"
                                                                >9hrs ago</span
                                                            >
                                                        </div>
                                                        <div
                                                            class="comments font_size_14"
                                                        >
                                                            Lorem Ipsum is
                                                            simply dummy text of
                                                            the printing and
                                                            typesetting
                                                            industry.
                                                        </div>
                                                        <div
                                                            class="reply grey_color font_size_14"
                                                        >
                                                            Reply
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="button_btm text-right">
                            <a
                                href="#"
                                class="btn btn_orange bg_primary_orange text_white ml_20"
                                >Back to listing</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "Order_detail",
    components: {},
    mounted() {
        // document.body.classList.add('cart-custom-class');
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });

        $(function () {
            $(".acc__title").click(function (j) {
                var dropDown = $(this)
                    .closest(".acc__card")
                    .find(".acc__panel");
                $(this)
                    .closest(".acc")
                    .find(".acc__panel")
                    .not(dropDown)
                    .slideUp();

                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                } else {
                    $(this)
                        .closest(".acc")
                        .find(".acc__title.active")
                        .removeClass("active");
                    $(this).addClass("active");
                }

                dropDown.stop(false, true).slideToggle();
                j.preventDefault();
            });
        });
        /* eslint-enable */
    }
};
</script>
